import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TESelectLink extends TKCustomElementFactory {
    selectField?: HTMLSelectElement;

    constructor() {
        super();

        this.selectField = this.querySelector('select') || undefined;
    }

    connectedCallback(): void {
        if (!this.selectField) throw new Error('TESelectLink: no select field');

        const action = this.redirect.bind(this);
        this.pushListener({ event: 'change', element: this.selectField, action });
    }

    redirect() {
        const selectedOption = this.selectField!.options[this.selectField!.selectedIndex];
        if (!selectedOption) return;

        const link = selectedOption.getAttribute('data-tk-link');

        link && (window.location.href = link);
    }
}
